import * as React from 'react'
import { View, TouchableOpacity, Text } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'
import theme from '@theme/Theme'

interface Option {
  label: string
  value: any
}

interface Props {
  activeColor?: boolean
  inactiveColor?: boolean
  focused?: boolean
  indicator?: number
  item: Option
  leftIcon?: IconName
  selected?: boolean
  onItemSelected?: () => void
  rightIcon?: IconName
  disabled?: boolean
  ellipsized?: boolean
}

const Tag = ({
  activeColor,
  focused,
  indicator,
  item,
  leftIcon,
  onItemSelected,
  selected,
  rightIcon,
  disabled,
  inactiveColor,
  ellipsized,
}: Props) => {
  return (
    <Container
      disabled={disabled}
      activeColor={activeColor}
      inactiveColor={inactiveColor}
      focused={focused}
      selected={selected}
      activeOpacity={0.9}
      onPress={onItemSelected}>
      {leftIcon && (
        <LeftIcon>
          <Icon name={leftIcon} size={18} color={selected ? theme.colors.background : theme.colors.primary} />
        </LeftIcon>
      )}
      <Label
        activeColor={activeColor}
        selected={selected}
        numberOfLines={ellipsized ? 1 : undefined}
        ellipsizeMode={ellipsized ? 'tail' : undefined}
        ellipsized={ellipsized}>
        {item.label}
      </Label>
      {indicator !== undefined && (
        <Indicator selected={selected}>
          <IndicatorValue selected={selected}>{indicator}</IndicatorValue>
        </Indicator>
      )}
      {rightIcon && (
        <RightIcon>
          <Icon name={rightIcon} size={18} color={selected ? theme.colors.background : theme.colors.primary} />
        </RightIcon>
      )}
    </Container>
  )
}

export default Tag

const Container = styled(TouchableOpacity)<{
  activeColor?: boolean
  focused?: boolean
  selected?: boolean
  inactiveColor?: boolean
}>`
  flex-direction: row;
  align-items: center;
  border-radius: 36px;
  background-color: ${(props) =>
    props.selected
      ? props.theme.colors.primary
      : props.activeColor
      ? props.theme.colors.secondaryActive
      : props.inactiveColor
      ? props.theme.colors.secondaryActive
      : props.theme.colors.background};
  padding: 10px 12px;
  ${(props) =>
    props.focused !== undefined &&
    `border: 2px solid ${props.selected ? props.theme.colors.background : props.theme.colors.primary};`}
`
const Label = styled(Text)<{ activeColor?: boolean; selected?: boolean; ellipsized?: boolean }>`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) =>
    props.selected
      ? props.theme.colors.background
      : props.activeColor
      ? props.theme.colors.primary
      : props.theme.colors.primaryText};
  ${(props) => props.ellipsized && `max-width: 200px;`}
`
const LeftIcon = styled(View)`
  margin-right: 8px;
`
const RightIcon = styled(View)`
  margin-left: 8px;
`
const Indicator = styled(View)<{ selected?: boolean }>`
  min-height: 18px;
  min-width: 18px;
  border-radius: 24px;
  background-color: ${(props) => (props.selected ? props.theme.colors.background : props.theme.colors.primary)};
  justify-content: center;
  align-items: center;
  padding: 0 4px;
  margin-left: 8px;
`
const IndicatorValue = styled(Text)<{ selected?: boolean }>`
  text-align: center;
  ${(props) => props.theme.fonts.Caption1};
  font-size: 9px;
  color: ${(props) => (props.selected ? props.theme.colors.primary : props.theme.colors.background)};
  line-height: 12px;
`
